import React, { useState } from 'react';
import { BeatLoader } from 'react-spinners';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer } from '../../actions/drawerActions';
import { portfolioAdded } from '../../actions/portfolioActions';
import { UploadCsvFile } from "../../Apis/UploadCsvFile";
import { ConfirmCsvUpload } from '../../Apis/ConfirmCsvUpload';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import { handleApiError } from '../../actions/notificationActions';
import Toaster from '../../Components/Toaster/Toaster';
import { useEffect } from 'react';
import { GetPlaidAccountHoldings, GetPlaidAccounts, PlaidImportPortfolio, setSelectedPlaidAccountId } from '../../actions/plaidActions';
import TagManager from 'react-gtm-module';

function PlaidImportDrawer() {
    const dispatch = useDispatch();

    const [importStage, setImportStage] = React.useState(1);
    const [portfolioName, setPortfolioName] = useState('');
    const [isHedgeableSelected, setIsHedgeableSelected] = useState(true);
    const plaidAccounts = useSelector(state => state.plaid.plaidAccounts);
    const plaidLoading = useSelector(state => state.plaid.isLoading);
    const plaidError = useSelector(state => state.plaid.error);
    const plaidHoldings = useSelector(state => state.plaid.accountData);



    console.log("accounts", plaidAccounts)
    const Confirm = async () => {
        dispatch(PlaidImportPortfolio(portfolioName)).then(()=>{
            if (plaidError===null){
                TagManager.dataLayer({
                    dataLayer: {
                      event: 'Add Portfolio',
                      userType: sessionStorage.getItem("selectedAcType"),
                      user_id: sessionStorage.getItem("clientId"),
                      creation_method:'Plaid Account'
                    },
                  });
                dispatch(portfolioAdded())
                dispatch(closeDrawer())
            }
        })
    }
    console.log("holdings", plaidHoldings)

    useEffect(() => {
        if ((Object.keys(plaidAccounts).length === 0) && (plaidLoading === false) && plaidError === null) {
            dispatch(GetPlaidAccounts())
        }
    })
    const renderTable = (assets) => {
        return (
            <table>
                <thead>
                    <tr>
                        <th>Symbol</th>
                        <th>Quantity</th>
                        <th>Description</th>
                        <th>Close Price</th>

                    </tr>
                </thead>
                <tbody>
                    {assets.map(asset => (
                        <tr key={asset.security_id}>
                            <td>{asset.ticker}</td>
                            <td>{asset.quantity}</td>
                            <td>{asset.name}</td>
                            <td>{asset.close_price}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };
    function return_button(value) {
        console.log(value);
        if (value.type === "investment" && value.linked === 0) {
            return (
                <button className="select-btn" onClick={() => AccountSelected(value)}>
                    Select
                </button>
            );
        } else if (value.type === "investment" && value.linked === 1) {
            return <p className="linked-text">LINKED</p>;
        } else {
            return (
                <button className="select-btn disabled" disabled={true}>
                    Select
                </button>
            );
        }
    }
    const AccountSelected = (selectedValues) => {
        dispatch(setSelectedPlaidAccountId(selectedValues.account_id))
        setImportStage(2)
        dispatch(GetPlaidAccountHoldings());
        console.log(selectedValues)
    };


    return (
        <>
            <div className="toast-container">
                <Toaster />
            </div>
            <div className="drawer">
                {plaidLoading ? (
                    <div className="loading-overlay">
                        <BeatLoader color="#60034C" loading={plaidLoading} size={30} />
                    </div>) : (
                    <>
                        <div className="drawer-header">
                            <h1>Import New Portfolio</h1>
                            <div className="actions">
                                <button className="close-drawer" onClick={() => dispatch(closeDrawer())}>✕</button>
                            </div>
                        </div>
                        <>
                            <div className="round">
                                <div className="round_card_title">
                                    <img className="" src='./Assets/Wave.svg'></img>
                                    <p className="round_title_text">Select Account To Link</p>
                                </div>
                                <div className="round_card_title" onClick={() => { setImportStage(2) }}>
                                    <img className="" src='./Assets/BankConnect.svg'></img>
                                    <p className="round_title_text">Verify Import</p>
                                </div>
                                <div className="round_card_title">
                                    <img className="" src='./Assets/Docs.svg'></img>
                                    <p className="round_title_text">Complete</p>
                                </div>
                            </div>
                            {importStage === 1 &&
                                (
                                    <div className="main-content">
                                        <div className="ai-accountsummary">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Account Name</th>
                                                        <th>Account Type</th>
                                                        <th>Overall Value</th>
                                                        <th>Currency</th>
                                                        <th></th>
                                                    </tr>
                                                    {(Object.keys(plaidAccounts).length > 0) && plaidAccounts.map((value, i) => (
                                                        <tr>
                                                            <td>{value.name}</td>
                                                            <td>{value.type}</td>
                                                            <td>{value.balance}</td>
                                                            <td>{value.currency}</td>
                                                            <td>
                                                                <div className="plaid-select">{return_button(value)}</div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* {errorMessage !== "" && <ErrorComponent message={errorMessage}> </ErrorComponent>} */}
                                    </div>


                                )
                            }
                            {importStage === 2 &&
                                (
                                    <div className="main-content">
                                        <div className="toogle-switch">
                                            <h2>Unhedgeable</h2>
                                            <FormControlLabel control={
                                                <Switch
                                                    checked={isHedgeableSelected}
                                                    onChange={() => setIsHedgeableSelected(!isHedgeableSelected)}
                                                />} />
                                            <h2>Hedgeable</h2>
                                        </div>
                                        {Object.keys(plaidHoldings).length > 0 && (isHedgeableSelected ? renderTable(plaidHoldings.hedgeable) : renderTable(plaidHoldings.unhedgeable))}

                                        <div className="button-div">
                                            <button className="ai-btn line grey" onClick={() => setImportStage(1)}>
                                                Back
                                            </button>
                                            <button className="ai-btn line primary" onClick={() => setImportStage(3)}>
                                                Import
                                            </button>
                                            <button className="ai-btn solid secondary" onClick={() => setImportStage(1)}>
                                                Exit
                                            </button>
                                        </div>
                                    </div>
                                )}
                            {importStage === 3 &&
                                (
                                    <div className="main-content">
                                        <input
                                            type="text"
                                            placeholder="Portfolio Name"
                                            value={portfolioName}
                                            onChange={(e) => setPortfolioName(e.target.value)}
                                        />

                                        <div className="button-div">
                                            <button className="ai-btn line grey" onClick={() => setImportStage(2)}>
                                                Back
                                            </button>
                                            <button className="ai-btn line primary" onClick={() => Confirm()}>
                                                Confirm
                                            </button>
                                        </div>
                                    </div>
                                )}
                        </>
                    </>
                )}
            </div>
        </>
    );
}

export default PlaidImportDrawer;
